<template>
  <div class="d-flex flex-wrap">
    <b-skeleton height="100vh" width="100%" />
  </div>
</template>
<script>
import { BSkeleton } from 'bootstrap-vue'
export default {
  components: { BSkeleton },
}
</script>
